var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24L18 30V8L12 14H6V24H12Z",
    fill: "#44D62C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2426 14.6558C24.5858 16.9989 24.5858 20.7979 22.2426 23.1411",
    stroke: "#44D62C",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0711 11.8274C28.9763 15.7326 28.9763 22.0643 25.0711 25.9695",
    stroke: "#44D62C",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.ddeded788809035a64090c89d50e99e3.svg";
export { ForwardRef as ReactComponent };